import attendances from 'translations/en/manager/attendances'
import audit from 'translations/en/manager/audit'
import availabilities from 'translations/en/manager/availabilities'
import bulletins from 'translations/en/manager/bulletins'
import contactLists from 'translations/en/manager/contactLists'
import dashboard from 'translations/en/manager/dashboard'
import imports from 'translations/en/manager/imports'
import punch from 'translations/en/manager/punch'
import projects from 'translations/en/manager/projects'
import reports from 'translations/en/manager/reports'
import schedule from 'translations/en/manager/schedule'
import scheduleCapacity from 'translations/en/manager/scheduleCapacity'
import scheduleIssues from 'translations/en/manager/scheduleIssues'
import scheduleTemplates from 'translations/en/manager/scheduleTemplates'
import timeOffs from 'translations/en/manager/timeOffs'
import users from 'translations/en/manager/users'

export default {
  ATTENDANCES: `Attendances`,
  AUDIT: `Audit`,
  AVAILABILITIES: `Availabilities`,
  BULLETINS: `Bulletins`,
  CONTACT: `Contact Lists`,
  CONTACT_LISTS: `Contact Lists`,
  DASHBOARD: `Dashboard`,
  PUNCH: `Punch Cards`,
  PROJECTS: `Projects`,
  USER_LIST: `Users`,
  SCHEDULE: `Schedule`,
  SCHEDULE_TEMPLATES: `Schedule Templates`,
  TIME_OFFS: `Time off`,
  TIMEOFF: `Time off`,
  REPORTS_LIST: `Reports`,
  REPORTS: `Reports`,
  TEMPLATES: `Templates`,
  USERS: `Users`,
  POSITIONS: `Positions`,
  VALIDATION: `Validation`,
  COST_WARNING: `Charges may apply.`,
  NAV: {
    OTHER: `Other`,
    MANAGE_FAVORITES: `Manage my favorite links`,
    FAVORITES_MODAL: {
      TITLE: `Favorite links`,
      SUMMARY: `This interface lets you change the links that appear at the top of the manager portal.`,
      TOO_MANY_FAVORITES: `You have a lot of favorites! To make sure you can access all of them, only the icon will be shown in the navigation bar.`
    }
  },
  breadcumbs: {
    ACTIVE: 'Current page'
  },
  SAVED_PRESET_MODAL: {
    TITLE: `Save search preset`,
    SUMMARY: `You can save your current search presets to reuse it easily in the future.`,
    NAME_REQUIRED: 'The name of the preset is required',
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the preset name`,
      DESCRIPTION: ''
    }
  },
  attendances,
  audit,
  availabilities,
  bulletins,
  contactLists,
  dashboard,
  imports,
  punch,
  projects,
  reports,
  schedule,
  scheduleCapacity,
  scheduleIssues,
  scheduleTemplates,
  timeOffs,
  users
}
